import { render } from "./CollaborationBoard.vue?vue&type=template&id=33251882&scoped=true"
import script from "./CollaborationBoard.vue?vue&type=script&lang=js"
export * from "./CollaborationBoard.vue?vue&type=script&lang=js"

import "./CollaborationBoard.vue?vue&type=style&index=0&id=33251882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33251882"]])

export default __exports__